import contratosRotas from './contratos/ContratosRotas'
import requisicoesRotas from './requisicoes/RequisicoesRotas'
import pagamentosRotas from './pagamentos/PagamentosRotas'

export default {
    path: 'apoios',
    name: 'Gescon_Apoios',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [contratosRotas, requisicoesRotas, pagamentosRotas]
}
